<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="举报类型">
                <a-select v-model="queryParam.reportType" placeholder="请选择" style="width: 100%" allow-clear>
                  <a-select-option :value="0">广告软文</a-select-option>
                  <a-select-option :value="1">标题党</a-select-option>
                  <a-select-option :value="2">内容低俗</a-select-option>
                  <a-select-option :value="3">抄袭侵权</a-select-option>
                  <a-select-option :value="4">其它问题</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="处理状态">
                <a-select v-model="queryParam.reportProcessing" placeholder="请选择" style="width: 100%" allow-clear>
                  <a-select-option :value="0">待处理</a-select-option>
                  <a-select-option :value="1">已处理</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="举报文章类型">
                <a-select v-model="queryParam.reportArticleType" placeholder="请选择" style="width: 100%" allow-clear>
                  <a-select-option :value="0">文章</a-select-option>
                  <a-select-option :value="1">评论文章</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="举报用户名称">
                <a-input v-model="queryParam.userName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="举报用户手机号">
                <a-input v-model="queryParam.userMobile" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="举报说明">
                <a-input v-model="queryParam.reportExplain" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="创建时间">
                <a-range-picker
                  v-model="value"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeTime"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['article:report:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        class="center-table"
      >
        <span slot="reportType" slot-scope="text, record">
          <a-tag :color="getReportTypeColor(record.reportType)">
            {{ getReportTypeText(record.reportType) }}
          </a-tag>
        </span>
        <span slot="reportProcessing" slot-scope="text, record">
          <a-tag :color="record.reportProcessing === 1 ? 'green' : 'orange'">
            {{ record.reportProcessing === 1 ? '已处理' : '待处理' }}
          </a-tag>
        </span>
        <span slot="reportArticleType" slot-scope="text, record">
          {{ record.reportArticleType === 0 ? '文章' : '评论文章' }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ record.createTime || '--' }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.detailDrawer.show(record)" v-hasPermi="['article:report:query']">详情</a>
          <a-divider type="vertical" v-hasPermi="['article:report:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['article:report:remove']">删除</a>
        </span>
      </a-table>
      <DetailDrawer ref="detailDrawer" />
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>
<script>
import { pageReport, delReport } from '@/api/tutorial/report'
import moment from 'moment'
import DetailDrawer from './modules/DetailDrawer'

export default {
  name: 'TutorialReport',
  components: {
    DetailDrawer,
  },
  data() {
    return {
      list: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        creator: undefined,
        reportArticleId: undefined,
        reportArticleType: undefined,
        reportExplain: undefined,
        reportProcessing: undefined,
        reportType: undefined,
        userMobile: undefined,
        userName: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        sortField: undefined,
        sortOrder: undefined,
      },
      total: 0,
      value: [],
      loading: false,
      tableSize: 'default',
      tableBordered: true,
      selectedRowKeys: [],
      selectedRows: [],
      single: true,
      multiple: true,
      ids: [],
      columns: [
        {
          title: '举报类型',
          dataIndex: 'reportType',
          scopedSlots: { customRender: 'reportType' },
          align: 'center',
        },
        {
          title: '处理状态',
          dataIndex: 'reportProcessing',
          scopedSlots: { customRender: 'reportProcessing' },
          align: 'center',
        },
        {
          title: '举报文章类型',
          dataIndex: 'reportArticleType',
          scopedSlots: { customRender: 'reportArticleType' },
          align: 'center',
        },
        {
          title: '文章/评论名称',
          dataIndex: 'reportArticleName',
          align: 'center',
        },
        {
          title: '举报用户名称',
          dataIndex: 'userName',
          align: 'center',
        },
        {
          title: '举报用户手机号',
          dataIndex: 'userMobile',
          align: 'center',
        },
        {
          title: '举报说明',
          dataIndex: 'reportExplain',
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          width: 160,
        },
      ],
    }
  },
  methods: {
    getList() {
      this.loading = true
      pageReport(this.queryParam).then((res) => {
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        creator: undefined,
        reportArticleId: undefined,
        reportArticleType: undefined,
        reportExplain: undefined,
        reportProcessing: undefined,
        reportType: undefined,
        userMobile: undefined,
        userName: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        sortField: undefined,
        sortOrder: undefined,
      }
      this.value = []
      this.handleQuery()
    },
    onChangeTime(e) {
      if (e && e.length === 2) {
        this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
        this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
      } else {
        this.queryParam.createBeginTime = undefined
        this.queryParam.createEndTime = undefined
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    getReportTypeText(type) {
      const typeMap = {
        0: '广告软文',
        1: '标题党',
        2: '内容低俗',
        3: '抄袭侵权',
        4: '其它问题',
      }
      return typeMap[type] || '--'
    },
    getReportTypeColor(type) {
      const colorMap = {
        0: 'red',
        1: 'orange',
        2: 'purple',
        3: 'blue',
        4: 'grey',
      }
      return colorMap[type] || 'grey'
    },
    handleDelete(row) {
      var that = this
      let ids = []
      if (row && row.id) {
        ids = [{ id: row.id }]
      } else {
        if (!this.ids || this.ids.length === 0) {
          this.$message.warning('请选择要删除的数据', 3)
          return
        }
        this.ids.forEach((v) => {
          ids.push({ id: v })
        })
      }
      this.$confirm({
        title: row && row.id ? '是否确认删除此数据?' : `是否确认删除选中的 ${ids.length} 条数据?`,
        onOk() {
          return delReport(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
  },
  created() {
    this.getList()
  },
}
</script>
<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-page-search-wrapper .ant-form-item {
  margin-bottom: 16px;
}

.center-table .ant-table-thead > tr > th {
  text-align: center;
  white-space: nowrap;
}

.center-table .ant-table-tbody > tr > td {
  text-align: center;
  white-space: nowrap;
}

.center-table .ant-table-thead > tr > th,
.center-table .ant-table-tbody > tr > td {
  vertical-align: middle;
}

.ant-table-pagination {
  margin-top: 16px;
  text-align: center;
}

.center-table {
  width: 100%;
}

.center-table .ant-table-container {
  width: 100%;
}

.center-table .ant-table-content {
  text-align: center;
}
</style>
